import { useMemo } from 'react';
import { useIsHcoCharacteristicsDisabled } from '@/api/queries/filter/hcoCharacteristicsScope';
import { FILTER_SECTIONS, SectionConfig } from '../filters.config';

export const useVisibleFilterSections = (): SectionConfig[] => {
  const isHcoCharacteristicsDisabled = useIsHcoCharacteristicsDisabled();

  return useMemo(() => {
    if (!isHcoCharacteristicsDisabled) return FILTER_SECTIONS;

    return FILTER_SECTIONS.map(section =>
      section.id === 'hcoCharacteristics'
        ? { ...section, disabled: true, tooltipKey: 'global.filters.hcoCharacteristicsDisabledTooltip' }
        : section,
    );
  }, [isHcoCharacteristicsDisabled]);
};
